import clsx from 'clsx'
import {cloneDeep, debounce, find, has, isEmpty, isEqual, mapValues, omit, pick, some} from 'lodash'
import moment from 'moment'
import {FC, useCallback, useEffect, useMemo, useRef, useState} from 'react'
import {useIntl} from 'react-intl'
import {useLocation, useNavigate, useParams} from 'react-router-dom'
import {toast} from 'react-toastify'
import {CSSTransition} from 'react-transition-group'
import {KTSVG, StorageHelpers} from '../../../../../_gori/helpers'
import {blockPopUp} from '../../../../../_gori/helpers'
import {useMeter} from '../../../../../_gori/helpers/components/MeterProvider'
import {useStatesGlobal} from '../../../../../_gori/helpers/components/StatesGlobalProvider'
import {OrderDetailSkeleton} from '../../../../../_gori/helpers/components'
import useCancelToken from '../../../../../_gori/hooks/UseCancelToken'
import UseRoutesPermission from '../../../../../_gori/hooks/UseRoutesPermission'
import {
  Button,
  ButtonBack,
  InputDate,
  SelectNoFormik,
  SplitButtonDropdown,
  ValidationErrorModal,
  RequiredVerifyEmail,
  InputTextFormik,
} from '../../../../../_gori/partials/widgets'
import {useAuth} from '../../../auth'
import {
  ActionsDetailButton,
  CustomsInternational,
  EditAddress,
  ManageTagModal,
  NoticeCreateLabelModal,
  OrderChildModal,
  PackageInfo,
  PresetApplyButton,
  ShipmentTable,
  InsufficientBalanceModal,
} from '../../../orders'
import ShipmentService from '../../../shipments/core/_requests'
import SettingsService from '../../../settings/core/_requests'
import OrderHelper, {isCreatedWithinLast30Days} from '../../core/_helpers'
import {INSURANCE_TYPE, OrderChildModalName, OrderStatus, OrderType} from '../../core/_const'
import OrderService from '../../core/_requests'
import {ROUTES} from '../../../../../_gori/constants/_routes'
import {useOrderChild} from '../../hooks'
import {OrderChildRate, OrderChildRateForwardRefProps} from './OrderChildRate'
import {isInternationalByAddress} from './rateHelpers'
import {Policy, PolicySource} from '../../../opt/core/_const'
import OptService from '../../../opt/core/_requests'
import Cookies from 'js-cookie'
import {ACCEPT_TERM_UPIC_KEY, TABLE_KEY_COLUMN} from '../../../../../_gori/constants'
import {RATE_SERVICES_KEY} from '../../../../../_gori/constants'
import {USPS_MANIFEST_SERVICES} from '../../../../../_gori/constants/_const'
import OrderDetail from './OrderDetail'

const OrderChild: FC = () => {
  const intl = useIntl()
  const orderHelper = OrderHelper()
  const {setMeterChange} = useMeter()
  const {currentUser, setCurrentUser} = useAuth()
  const renderFirst = useRef(true)
  const isShowHideInitialized = useRef(false)
  const navigate = useNavigate()
  const location = useLocation()
  const state: any = location.state
  const dataCopy = state?.dataCopy || null
  const fromCreateOrder = state?.fromCreateOrder || false
  const fromUrl: string | null = state?.fromUrl || null
  const {newCancelToken, isCancel} = useCancelToken()
  const params = useParams()
  const {statesGlobal} = useStatesGlobal()
  const carriers = statesGlobal.carriers
  const [loading, setLoading] = useState<{
    first: boolean
    save: boolean
    rate: boolean
    createOrder: boolean
    createLabel: boolean
    updateRate: boolean
    assignTag: boolean
    restore: boolean
  }>({
    first: true,
    save: false,
    rate: false,
    createOrder: false,
    createLabel: false,
    updateRate: false,
    assignTag: false,
    restore: false,
  })

  const [dataTags, setDataTags] = useState<any>([])
  const [action, setAction] = useState<'create_order' | 'save' | 'create_label' | undefined>()
  const [immediateManifestFlag, setImmediateManifestFlag] = useState<boolean>(false)
  const [selectedMode, setSelectedMode] = useState<'label' | 'manifest'>('label')
  const [showModal, setShowModal] = useState<{
    reship: boolean
    noticeCreateLabel: boolean
    manageTag: boolean
    requiredVerifyEmail: boolean
    insufficientFunds: boolean
  }>({
    reship: false,
    noticeCreateLabel: false,
    manageTag: false,
    requiredVerifyEmail: false,
    insufficientFunds: false,
  })
  const [insufficientBalanceLogId, setInsufficientBalanceLogId] = useState<
    string | number | undefined
  >()

  const onSubmit = useCallback(
    async (values) => {
      values = {
        ...values,
        ship_by_date:
          isEmpty(values.ship_by_date?.format()) || values.ship_by_date?.format() === 'Invalid date'
            ? undefined
            : values.ship_by_date?.format(),
      }

      if (action === 'create_order') {
        postCreateOrder(values).catch(() => {})
      }

      if (action === 'save') {
        formik.setFieldValue('insurance_option.upic_terms_of_service', null)
        handleSaveOrders(values).catch(() => {})
      }

      if (action === 'create_label') {
        if (!currentUser?.email_verified) {
          StorageHelpers.setItemLocalStorage('TEMPORARY_ORDER', formik.values)
          setShowModal((prev) => ({...prev, requiredVerifyEmail: true}))
          return
        }
        handleCreateLabel(values)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [action]
  )

  useEffect(() => {
    return () => {
      StorageHelpers.removeItemLocalStorage(RATE_SERVICES_KEY)
    }
  }, [])

  const {
    row,
    validateAddress,
    validateSchema,
    data,
    setData,
    getInitValue,
    formik,
    handleAddNewItem,
    handleDeleteItem,
    currentDimensionUnit,
    setCurrentDimensionUnit,
    currentWeightUnit,
    setCurrentWeightUnit,
    setScrollToErrors,
    isAccept,
    setIsAccept,
    isErrorUpicAccept,
    setIsErrorUpicAccept,
  } = useOrderChild({dataCopy, id: params?.id, setLoading, onSubmit})

  const rateRef = useRef<OrderChildRateForwardRefProps>(null)

  const [fromToModal, setFormToModal] = useState<any>({
    show: false,
    name: undefined,
    data: {},
    validate: {},
  })
  const [validationErrors, setValidationErrors] = useState<any>()
  const {routes} = UseRoutesPermission()
  const [canSave, setCanSave] = useState<boolean>(!params?.id)
  const [checkValidateLeft, setCheckValidateLeft] = useState<boolean>(false)
  const currentValue = useRef<any>(null)
  const [isClickMultiTags, setIsClickMultiTags] = useState<boolean>(true)
  const validateTimeoutRef = useRef<NodeJS.Timeout | null>(null)

  const [showHide, setShowHide] = useState<{
    shipmentDetail: boolean
    custom: boolean
    orderDetail: boolean
  }>({shipmentDetail: false, custom: true, orderDetail: true})

  useEffect(() => {
    if (!isShowHideInitialized.current && data?.status !== undefined) {
      isShowHideInitialized.current = true
      setShowHide((prev) => ({
        ...prev,
        shipmentDetail: data.status === OrderStatus.SHIPPED,
      }))
    }
  }, [data?.status])

  const hasPermissionView = useMemo(() => {
    return routes.ORDERS_UPDATE.hasPermission || routes.ORDERS_CREATE.hasPermission
      ? false
      : routes.ORDERS_VIEW.hasPermission
  }, [
    routes.ORDERS_CREATE.hasPermission,
    routes.ORDERS_UPDATE.hasPermission,
    routes.ORDERS_VIEW.hasPermission,
  ])

  const isShippedPage = useMemo(() => {
    return data?.status === OrderStatus.SHIPPED
  }, [data?.status])

  const shipmentVisibleColumns = useMemo(() => {
    const baseColumns = [
      TABLE_KEY_COLUMN.DATE,
      TABLE_KEY_COLUMN.SERVICE,
      TABLE_KEY_COLUMN.TRACKING_NUMBER,
      TABLE_KEY_COLUMN.ACTIONS,
      TABLE_KEY_COLUMN.ADD_ON_SERVICES,
    ]

    if ((data?.shipments?.length ?? 0) > 1) {
      return [
        TABLE_KEY_COLUMN.DATE,
        TABLE_KEY_COLUMN.SERVICE,
        TABLE_KEY_COLUMN.SHIP_TO,
        TABLE_KEY_COLUMN.SHIP_FROM,
        TABLE_KEY_COLUMN.TRACKING_NUMBER,
        TABLE_KEY_COLUMN.PACKAGE_INFO,
        TABLE_KEY_COLUMN.ACTIONS,
        TABLE_KEY_COLUMN.ADD_ON_SERVICES,
      ]
    }

    return baseColumns
  }, [data?.shipments?.length])

  const isA1 = useMemo(() => {
    return !!data?.a1_batch_id
  }, [data?.a1_batch_id])

  const isDisablePage = useMemo(() => {
    return isShippedPage || loading.save || loading.createOrder || loading.createLabel
  }, [isShippedPage, loading.createLabel, loading.createOrder, loading.save])

  const lastIsUspsRef = useRef<boolean>(false)
  const isUsps = useMemo(() => {
    const service = formik.values?.service

    if (!service) return lastIsUspsRef.current
    const result = USPS_MANIFEST_SERVICES.includes(service)
    lastIsUspsRef.current = result
    return result
  }, [formik.values?.service])
  const hasSelectedShipmentDate = !isEmpty(formik.values.ship_by_date)
  const shipmentDatePickerProps = useMemo(
    () => ({
      sx: {
        backgroundColor: ((isDisablePage || hasPermissionView) && '#eff2f5') || '#ffffff',
        '.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
          borderColor: hasSelectedShipmentDate ? '#14B8A6' : undefined,
        },
        '.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: hasSelectedShipmentDate ? '#14B8A6' : undefined,
        },
        '.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: '#14B8A6',
        },
      },
    }),
    [hasPermissionView, hasSelectedShipmentDate, isDisablePage]
  )

  const handleClickTag = useMemo(
    () =>
      debounce(async (item) => {
        const isChecked = (formik.values?.tags || []).includes(item.id)

        const payload = {
          tag_id: item.id,
          order_ids: [params?.id],
          mode: isChecked ? 'remove' : 'add',
        }

        setLoading((prev) => ({...prev, assignTag: true}))

        try {
          const {tags} = await OrderService.assignTag(payload, {
            cancelToken: newCancelToken(),
          })
          if (tags) {
            formik.setFieldValue(
              'tags',
              isChecked
                ? formik.values?.tags.filter((id) => id !== item.id)
                : [item.id, ...formik.values?.tags].sort((a, b) => b - a)
            )
          }
        } catch (error) {
          if (isCancel(error)) return
        } finally {
          setLoading((prev) => ({...prev, assignTag: false}))
        }
      }, 300),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [formik.values?.tags, params?.id, newCancelToken, isCancel]
  )

  // BEGIN: Tag
  const optionsTag = useMemo(() => {
    const _optionsTag = dataTags.map((item: any) => ({
      label: (
        <div className='d-flex align-items-center' onClick={() => handleClickTag(item)}>
          <div className='form-check'>
            <input
              aria-label='check'
              className='form-check-input cursor-pointer'
              type={'checkbox'}
              checked={formik.values?.tags?.includes(item.id)}
            />
          </div>
          <KTSVG
            path='/media/gori/orders/tag.svg'
            className='svg-icon-2 ms-2'
            style={{color: item.color}}
          />
          <span className='text-truncate'>{item.name}</span>
        </div>
      ),
      value: item.id.toString(),
    }))

    return [
      ..._optionsTag,
      {
        label: (
          <div className='mt-0'>
            <hr className='mt-n2 text-gray-600 me-n3 ms-n3 overflow-auto' />
            <span className='fw-bold fs-5'>{intl.formatMessage({id: 'MANAGE_TAGS'})}</span>
          </div>
        ),
        value: 'manage_tag',
      },
    ]
  }, [dataTags, formik.values?.tags, handleClickTag, intl])

  const getOptionsTag = useCallback(async () => {
    try {
      const config = {cancelToken: newCancelToken()}
      const {tags} = await OrderService.getTags(config)
      setDataTags(tags.map((item) => ({id: item.id, name: item.name, color: item.color})))
    } catch (error) {
      if (isCancel(error)) return
    }
  }, [isCancel, newCancelToken])

  useEffect(() => {
    getOptionsTag()

    return () => {}
  }, [getOptionsTag])
  // END: Tag

  // BEGIN: Immediate Manifest Setting
  const getManifestSetting = useCallback(async () => {
    try {
      const settings = await SettingsService.settings({cancelToken: newCancelToken()})
      setSelectedMode(settings?.manifest?.immediate_manifest ? 'manifest' : 'label')
    } catch (error) {
      if (isCancel(error)) return
    }
  }, [isCancel, newCancelToken])

  useEffect(() => {
    getManifestSetting()
    return () => {}
  }, [getManifestSetting])
  // END: Immediate Manifest Setting

  useEffect(() => {
    const allValue = cloneDeep({...formik.values})
    currentValue.current = pick(allValue, [
      'from',
      'to',
      'parcels',
      'reference1',
      'reference2',
      'reference3',
      'claim_category',
      'ship_by_date',
      'order_items',
      'custom_items',
      'international_option',
      'signature_confirmation',
      'extra_service',
      'insurance_option',
      'note',
    ])
    if (params?.id) {
      renderFirst.current = false
    }
    return () => {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.initialValues])

  // BEGIN: Detail Order
  const handleShipSuccess = useCallback(
    (url, navigateUrl?) => {
      StorageHelpers.setItemLocalStorage('cardorder', {hidden: true})
      window.dispatchEvent(new Event('storage'))
      setMeterChange(true)
      setShowModal((prev) => ({...prev, reship: false}))
      blockPopUp(url, '_blank')
      if (data?.status === OrderStatus.SHIPPED) {
        row.current = {parcels: 0, order_items: 0, custom_items: 0}
        getInitValue()
      } else if (navigateUrl) {
        navigate(navigateUrl)
      } else {
        navigate(-1)
      }
    },
    [data?.status, getInitValue, navigate, row, setMeterChange]
  )

  const postCreateOrder = useCallback(
    async (values) => {
      currentValue.current = pick({...formik.values}, [
        'from',
        'to',
        'parcels',
        'reference1',
        'reference2',
        'reference3',
        'claim_category',
        'ship_by_date',
        'order_items',
        'custom_items',
        'international_option',
        'signature_confirmation',
        'extra_service',
        'insurance_option',
        'note',
      ])

      setLoading((prev) => ({...prev, createOrder: true}))

      const dataParcels = orderHelper.buildParcels(cloneDeep(values?.parcels))
      const internationalOption = orderHelper.buildInternationalOption(
        values?.international_option,
        values?.custom_items
      )
      const estimatedRate =
        rateRef.current?.dataRates()?.chooseRate?.rate || values?.estimated_rate || null

      try {
        const {order, applied_rules} = await OrderService.store(
          {
            fields: {
              service: values.service ?? null,
              estimated_rate: estimatedRate,
              is_cheapest_rate: values?.is_cheapest_rate ?? false,
              preset_id: values?.preset_id ?? null,
              signature_confirmation: values.signature_confirmation ?? null,
              extra_service: values?.extra_service ?? null,
              insurance_option: values.insurance_option,
              reference1: values.reference1,
              reference2: values.reference2,
              reference3: values.reference3,
              ship_by_date: values.ship_by_date,
              order_items: values?.order_items,
              international_option: values.international ? internationalOption : null,
              claim_category: values?.claim_category || null,
              note: values?.note || null,
              ...values.from,
              ...values.to,
              parcel: dataParcels,
            },
          },
          {cancelToken: newCancelToken()}
        )
        if (order) {
          if (currentUser && !currentUser.existed_order) {
            setCurrentUser({
              ...currentUser,
              existed_order: true,
            })
          }
          navigate(`${ROUTES.ORDERS.BASE}/${order.id}`, {
            replace: true,
            state: {
              fromCreateOrder: true,
            },
          })
          renderFirst.current = true
          StorageHelpers.setItemLocalStorage('cardorder', {hidden: true})
          window.dispatchEvent(new Event('storage'))
          toast.success(intl.formatMessage({id: 'CREATED_SUCCESSFULLY'}))
          if (!isEmpty(applied_rules)) {
            const maxDisplay = 3
            const ruleNames = applied_rules
              .slice(0, maxDisplay)
              .map((rule: any) => rule.name)
              .join(', ')
            const remaining = applied_rules.length - maxDisplay

            toast.success(
              remaining > 0
                ? intl.formatMessage(
                    {id: 'SUCCESSFULLY_APPLIED_AUTOMATION_RULES_MORE'},
                    {ruleNames, remaining}
                  )
                : intl.formatMessage({id: 'SUCCESSFULLY_APPLIED_AUTOMATION_RULES'}, {ruleNames})
            )
          }
        }
      } catch (error: any) {
        if (isCancel(error)) return
        setValidationErrors(
          error?.response || {
            data: {error: {message: intl.formatMessage({id: 'NETWORK_ERROR'})}},
          }
        )
        throw error
      } finally {
        setLoading((prev) => ({...prev, createOrder: false}))
        setAction(undefined)
      }
    },
    [
      formik.values,
      intl,
      isCancel,
      navigate,
      newCancelToken,
      orderHelper,
      currentUser,
      setCurrentUser,
    ]
  )

  const handleSaveOrders = useCallback(
    async (values) => {
      try {
        currentValue.current = pick({...formik.values}, [
          'from',
          'to',
          'parcels',
          'reference1',
          'reference2',
          'reference3',
          'claim_category',
          'ship_by_date',
          'order_items',
          'custom_items',
          'international_option',
          'signature_confirmation',
          'extra_service',
          'insurance_option',
          'note',
        ])

        setLoading((prev) => ({...prev, save: true}))

        const dataParcels = orderHelper.buildParcels(cloneDeep(values?.parcels))
        const internationalOption = orderHelper.buildInternationalOption(
          values?.international_option,
          values?.custom_items
        )
        const estimatedRate =
          rateRef.current?.dataRates()?.chooseRate?.rate || values?.estimated_rate || null

        const res = await OrderService.update(
          params?.id,
          {
            fields: {
              service: values.service ?? null,
              estimated_rate: estimatedRate,
              is_cheapest_rate: values?.is_cheapest_rate ?? false,
              preset_id: values?.preset_id ?? null,
              signature_confirmation: values.signature_confirmation ?? null,
              extra_service: values?.extra_service ?? null,
              insurance_option: values.insurance_option,
              reference1: values.reference1,
              reference2: values.reference2,
              reference3: values.reference3,
              ship_by_date: values.ship_by_date,
              order_items: values?.order_items,
              international_option: values.international ? internationalOption : null,
              claim_category: values?.claim_category || null,
              note: values?.note || null,
              ...values.from,
              ...values.to,
              parcel: dataParcels,
            },
          },
          {cancelToken: newCancelToken()}
        )
        if (res) {
          StorageHelpers.setItemLocalStorage('cardorder', {hidden: true})
          window.dispatchEvent(new Event('storage'))
          toast.success(intl.formatMessage({id: 'UPDATED_SUCCESSFULLY'}))
          rateRef.current?.handleGetRates()
        }
      } catch (error: any) {
        if (isCancel(error)) return
        setValidationErrors(
          error?.response || {
            data: {error: {message: intl.formatMessage({id: 'NETWORK_ERROR'})}},
          }
        )
        throw error
      } finally {
        setLoading((prev) => ({...prev, save: false}))
        setAction(undefined)
      }
    },
    [formik.values, intl, isCancel, newCancelToken, orderHelper, params?.id]
  )

  const handleAddFunds = useCallback(async () => {
    try {
      // Shipped orders can't be updated via API — skip save and navigate directly
      if (data?.status !== OrderStatus.SHIPPED) {
        const values = {
          ...formik.values,
          ship_by_date:
            isEmpty(formik.values.ship_by_date?.format()) ||
            formik.values.ship_by_date?.format() === 'Invalid date'
              ? undefined
              : formik.values.ship_by_date?.format(),
        }
        if (params?.id) {
          formik.setFieldValue('insurance_option.upic_terms_of_service', null)
          await handleSaveOrders(values)
        } else {
          await postCreateOrder(values)
        }
      }
      setShowModal((prev) => ({...prev, insufficientFunds: false}))
      navigate(ROUTES.DEPOSITS.BASE)
    } catch {
      // Save failed — close this modal so the validation error modal is visible
      setShowModal((prev) => ({...prev, insufficientFunds: false}))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.status, handleSaveOrders, postCreateOrder, navigate, params?.id, formik.values])

  const handleCreateLabel = useCallback(
    async (values) => {
      if (
        values.insurance_option?.provider === INSURANCE_TYPE.BAE_GUARD &&
        isAccept &&
        !values.insurance_option?.upic_terms_of_service
      ) {
        setIsErrorUpicAccept(true)
        return
      }
      const _valueForm = cloneDeep(values)
      setLoading((prev) => ({...prev, createLabel: true}))

      const dataParcels = orderHelper.buildParcels(cloneDeep(_valueForm?.parcels))
      const internationalOption = orderHelper.buildInternationalOption(
        _valueForm?.international_option,
        _valueForm?.custom_items
      )

      const isReship = data?.status === OrderStatus.SHIPPED
      const payload = {
        id: data?.id,
        store_type: data?.store_type,
        store_id: data?.store_id,
        fields: {
          service: _valueForm.service,
          preset_id: values?.preset_id ?? null,
          delivery_option_id: _valueForm.delivery_option_id ?? null,
          signature_confirmation: _valueForm.signature_confirmation ?? null,
          extra_service: _valueForm?.extra_service ?? null,
          insurance_option: !!carriers[_valueForm?.service]?.options?.insurance.filter(
            (item) => item.enabled
          )?.length
            ? {
                ..._valueForm.insurance_option,
              }
            : null,
          reference1: _valueForm?.reference1,
          reference2: _valueForm?.reference2,
          reference3: _valueForm?.reference3,
          ship_by_date:
            isEmpty(_valueForm?.ship_by_date) || _valueForm?.ship_by_date === 'Invalid date'
              ? null
              : _valueForm?.ship_by_date,
          order_items: _valueForm?.order_items,
          international_option: _valueForm.international ? internationalOption : null,
          claim_category: _valueForm?.claim_category || null,
          note: _valueForm?.note || null,
          immediate_manifest: immediateManifestFlag ?? null,
          ..._valueForm.from,
          ..._valueForm.to,
          parcel: dataParcels,
        },
      }
      try {
        if (isAccept && values.insurance_option?.upic_terms_of_service) {
          let payloadAcceptTerms = {
            policies: [Policy.U_PIC],
            source: PolicySource.SHIPBAE,
          }
          const responseAcceptTerms = await OptService.acceptTermsUPic(payloadAcceptTerms)
          if (responseAcceptTerms.data.status) {
            Cookies.set(ACCEPT_TERM_UPIC_KEY, false)
          }
        }
        let response: any
        if (payload.store_type === OrderType.TEMU) {
          response = isReship
            ? await ShipmentService.reshipTemu(payload, {cancelToken: newCancelToken()})
            : await ShipmentService.storeTemu(payload, {cancelToken: newCancelToken()})
        } else {
          response = isReship
            ? await ShipmentService.reship(payload, {cancelToken: newCancelToken()})
            : await ShipmentService.store(payload, {cancelToken: newCancelToken()})
        }
        if (response) {
          if (currentUser && !currentUser!.existed_order) {
            setCurrentUser({
              ...currentUser!,
              existed_order: true,
            })
          }
          const navigateUrl = params?.id
            ? (() => {
                if (fromUrl) {
                  const [pathname, search] = fromUrl.split('?')
                  const urlParams = new URLSearchParams(search || '')
                  urlParams.set('status', OrderStatus.SHIPPED)
                  urlParams.set('page', '1')
                  return `${pathname}?${urlParams.toString()}`
                }
                return ROUTES.ORDERS.BASE + '?status=' + OrderStatus.SHIPPED
              })()
            : null
          handleShipSuccess(response.label_url, navigateUrl)
        }
      } catch (error: any) {
        if (isCancel(error)) return
        if (error?.response?.data?.error?.name === 'METER:INSUFFICIENT_BALANCE') {
          setInsufficientBalanceLogId(error?.response?.data?.error?.log_id)
          setShowModal((prev) => ({...prev, insufficientFunds: true}))
        } else {
          setValidationErrors(error?.response)
        }
      } finally {
        setLoading((prev) => ({...prev, createLabel: false}))
        setAction(undefined)
      }
    },
    [
      carriers,
      data?.id,
      data?.store_id,
      data?.store_type,
      data?.status,
      fromUrl,
      handleShipSuccess,
      isCancel,
      params?.id,
      newCancelToken,
      orderHelper,
      isAccept,
      setIsErrorUpicAccept,
      currentUser,
      setCurrentUser,
      immediateManifestFlag,
    ]
  )
  // END: Detail Order

  const handleRestoreOrder = useCallback(async () => {
    if (!params?.id) return
    setLoading((prev) => ({...prev, restore: true}))
    try {
      const res = await OrderService.restore(
        {order_ids: [params.id]},
        {cancelToken: newCancelToken()}
      )
      if (res) {
        toast.success(intl.formatMessage({id: 'RESTORED_ORDER_SUCCESSFULLY'}))
        row.current = {parcels: 0, order_items: 0, custom_items: 0}
        getInitValue()
      }
    } catch (error: any) {
      if (isCancel(error)) return
      setValidationErrors(error?.response)
    } finally {
      setLoading((prev) => ({...prev, restore: false}))
    }
  }, [params?.id, newCancelToken, intl, isCancel, row, getInitValue])

  const handleRemoveHold = useCallback(async () => {
    if (!params?.id) return
    setLoading((prev) => ({...prev, restore: true}))
    try {
      const res = await OrderService.removeHold(
        {order_ids: [params.id]},
        {cancelToken: newCancelToken()}
      )
      if (res) {
        toast.success(intl.formatMessage({id: 'REMOVED_HOLD_ORDER_SUCCESSFULLY'}))
        row.current = {parcels: 0, order_items: 0, custom_items: 0}
        getInitValue()
      }
    } catch (error: any) {
      if (isCancel(error)) return
      setValidationErrors(error?.response)
    } finally {
      setLoading((prev) => ({...prev, restore: false}))
    }
  }, [params?.id, newCancelToken, intl, isCancel, row, getInitValue])

  useEffect(() => {
    formik.setFieldValue(
      'international',
      isInternationalByAddress(formik.values?.from, formik.values?.to)
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps, no-sparse-arrays
  }, [
    formik.values.from.from_country,
    formik.values.from.from_state,
    formik.values.from.from_city,
    formik.values.to.to_country,
    formik.values.to.to_state,
    formik.values.to.to_city,
  ])
  // END: Check international

  // BEGIN: Clear ref3 and ref4 for non-USPS services
  useEffect(() => {
    if (formik.values.international || !formik.values.service?.startsWith('usps_')) {
      if (formik.values.reference3 || formik.values.reference4) {
        formik.setFieldValue('reference3', '')
        formik.setFieldValue('reference4', '')
      }
    }
  }, [formik, formik.values.service, formik.values.international])
  // END: Clear ref3 and ref4 for non-USPS services

  const objectValuesToString = (obj: any) => {
    return mapValues(obj, (value) => value?.toString?.() ?? '')
  }

  // BEGIN: Validate has can save
  useEffect(() => {
    const formattedParcels = Object.fromEntries(
      Object.entries(formik.values.parcels).map(([key, parcel]) => [
        key,
        objectValuesToString(orderHelper.formatParcels(parcel)),
      ])
    )
    const dataParcels = omit(
      pick(
        {
          ...formik.values,
          parcels: formattedParcels,
        },
        [
          'from',
          'to',
          'parcels',
          'reference1',
          'reference2',
          'reference3',
          'reference4',
          'claim_category',
          'ship_by_date',
          'order_items',
          'custom_items',
          'international_option',
          'signature_confirmation',
          'extra_service',
          'insurance_option',
          'note',
        ]
      ),
      'insurance_option.upic_terms_of_service'
    )

    const currentValueToCompare = {
      ...omit(currentValue.current, 'insurance_option.upic_terms_of_service'),
    }
    if (currentValue.current?.parcels) {
      Object.entries(currentValue.current?.parcels).forEach(([key, value]) => {
        currentValueToCompare.parcels[key] = objectValuesToString(value)
      })
    }

    if (params?.id && (isEqual(dataParcels, currentValueToCompare) || !currentValue.current)) {
      setCanSave(false)
      return
    }
    setCanSave(checkValidateLeft)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkValidateLeft, formik.values, currentValue.current, params?.id])
  useEffect(() => {
    const result = some(
      [
        'from',
        'to',
        'parcels',
        'custom_items',
        'international_option',
        'order_items',
        'check_weight',
        'check_package_count',
      ],
      (key) => has(formik.errors, key)
    )

    if (checkValidateLeft !== !result) {
      setCheckValidateLeft(!result)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.errors])
  // END: Validate has can save

  // BEGIN: Reset Validate
  useEffect(() => {
    validateTimeoutRef.current = setTimeout(() => {
      formik.validateForm()
    }, 800)

    return () => {
      if (validateTimeoutRef.current) {
        clearTimeout(validateTimeoutRef.current)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validateSchema])
  // END: Reset Validate

  const handleCloseRequiredVerifyEmailModal = () => {
    setShowModal((prev) => ({...prev, requiredVerifyEmail: false}))
  }

  const handleCreateLabelModal = () => {
    setShowModal((prev) => ({...prev, noticeCreateLabel: false}))
    setAction('create_label')
    setScrollToErrors(true)
    formik.handleSubmit()
  }
  // END: Notice about package type & service in Create Labelerm)

  const ButtonReship = () => {
    if (!(data?.status === OrderStatus.SHIPPED && routes.SHIPMENTS_CREATE.hasPermission)) {
      return null
    }

    return (
      <Button
        classNameDiv={'w-100'}
        className='btn btn-advanced-primary btn-sm w-100'
        label={intl.formatMessage({id: 'RESHIP'})}
        loadingText={intl.formatMessage({id: 'RESHIP'})}
        disabled={isA1}
        event={() => {
          setShowModal((prev) => ({...prev, reship: true}))
        }}
        icon={<KTSVG path='/media/gori/orders/upload_create.svg' className='svg-icon-2' />}
      />
    )
  }

  const ButtonCreateLabel = (className?: string) => {
    if (!params?.id || data?.status === OrderStatus.OPEN) {
      const selectedVisibleRate = rateRef.current?.dataRates()?.options?.find((item) => {
        return (
          item?.carrier_service === formik.values.service && Number.isFinite(Number(item?.rate))
        )
      })

      const canCreateLabel = checkValidateLeft && !!selectedVisibleRate

      const handleCreateLabelClick = () => {
        setImmediateManifestFlag(selectedMode === 'manifest')
        setScrollToErrors(true)
        formik.handleSubmit()
        if (canCreateLabel) {
          if (!rateRef.current?.serviceHasPackage()) {
            setShowModal((prev) => ({...prev, noticeCreateLabel: true}))
          } else {
            setAction('create_label')
          }
        }
      }

      return (
        <div
          className={clsx({
            'cursor-no-drop': loading.createLabel || loading.save || !canCreateLabel,
          })}
        >
          {isUsps ? (
            <SplitButtonDropdown
              label={
                selectedMode === 'manifest'
                  ? intl.formatMessage({id: 'CREATE_LABEL_AND_MANIFEST'})
                  : intl.formatMessage({id: 'CREATE_LABEL'})
              }
              options={[
                {
                  id: 'label',
                  label: intl.formatMessage({id: 'CREATE_LABEL'}),
                },
                {
                  id: 'manifest',
                  label: intl.formatMessage({id: 'CREATE_LABEL_AND_MANIFEST'}),
                },
              ]}
              selectedOption={selectedMode}
              onSelectOption={(id) => {
                setSelectedMode(id as 'label' | 'manifest')
                setImmediateManifestFlag(id === 'manifest')
              }}
              onMainClick={handleCreateLabelClick}
              fullWidth
              loading={loading.createLabel}
              icon={
                <KTSVG
                  path='/media/gori/orders/upload_create.svg'
                  className='svg-icon-2 text-white'
                />
              }
            />
          ) : (
            <Button
              className={clsx('btn btn-sm w-100 fw-bolder', className, {
                'btn-advanced-primary': canCreateLabel,
                'btn-advanced-primary cursor-no-drop': !canCreateLabel,
              })}
              classNameDiv={'w-100'}
              label={intl.formatMessage({id: 'CREATE_LABEL'})}
              loadingText={intl.formatMessage({id: 'CREATE_LABEL'})}
              event={() => {
                setImmediateManifestFlag(false)
                handleCreateLabelClick()
              }}
              icon={
                <KTSVG path='/media/gori/orders/upload_create.svg' className={clsx('svg-icon-2')} />
              }
              loading={loading.createLabel}
              disabled={isDisablePage}
            />
          )}
        </div>
      )
    }
    return null
  }

  return (
    <>
      {validationErrors && (
        <ValidationErrorModal
          handleClose={() => {
            setValidationErrors(undefined)
          }}
          response={validationErrors}
        />
      )}

      {showModal.noticeCreateLabel && (
        <NoticeCreateLabelModal
          show={showModal.noticeCreateLabel}
          handleClose={() => setShowModal((prev) => ({...prev, noticeCreateLabel: false}))}
          handleCreateLabel={handleCreateLabelModal}
          name={data?.status === OrderStatus.SHIPPED ? 'RESHIP' : 'CREATE_LABEL'}
        />
      )}

      {showModal.insufficientFunds && (
        <InsufficientBalanceModal
          show={showModal.insufficientFunds}
          handleClose={() => setShowModal((prev) => ({...prev, insufficientFunds: false}))}
          onAddFunds={handleAddFunds}
          logId={insufficientBalanceLogId}
        />
      )}

      {showModal.reship && (
        <OrderChildModal
          show={showModal.reship}
          handleClose={() => {
            getInitValue()
            setShowModal((prev) => ({...prev, reship: false}))
          }}
          handleSuccess={handleShipSuccess}
          name={OrderChildModalName.CREATE_LABEL}
          parentId={data.id}
        />
      )}
      {showModal.manageTag && (
        <ManageTagModal
          show={showModal.manageTag}
          dataInit={dataTags}
          handleClose={() => {
            setShowModal((prev) => ({...prev, manageTag: false}))
            setIsClickMultiTags(true)
          }}
          reloadOptionsTag={(newData) => {
            setDataTags(newData)
            formik.setFieldValue(
              'tags',
              formik.values?.tags.filter((tagId) => find(newData, {id: tagId}))
            )
          }}
        />
      )}
      {showModal.requiredVerifyEmail && (
        <RequiredVerifyEmail
          show={showModal.requiredVerifyEmail}
          closeModal={handleCloseRequiredVerifyEmailModal}
        />
      )}
      <CSSTransition appear in timeout={300} classNames='fade' unmountOnExit>
        <>
          {params?.id && loading.first ? (
            <div className='w-1275px m-center'>
              <OrderDetailSkeleton />
            </div>
          ) : (
            (() => {
              return (
                <div className='order-child-container w-100 mw-1275px m-center'>
                  <div className='sticky-top bg-page d-flex align-items-center flex-wrap col-12 py-4 gap-2 gap-xl-0'>
                    <div className='col-12 d-flex flex-wrap gap-2 justify-content-between order-child-header__main'>
                      <div className='d-flex gap-6 align-items-center'>
                        <div className='d-flex flex-row align-items-center'>
                          <ButtonBack
                            className='order-detail-title__back-button'
                            event={() => {
                              if (state?.fromUrl) {
                                navigate(state.fromUrl, {replace: true})
                              } else {
                                window.history.back()
                              }
                            }}
                          />
                          <button
                            type='button'
                            className='order-detail-title__back-arrow'
                            aria-label='Go back'
                            onClick={() => navigate(-1)}
                          >
                            <KTSVG path='/media/gori/left_arrow.svg' />
                          </button>
                          <span className='fs-1 fw-boldest text-dark'>
                            {intl.formatMessage({
                              id:
                                data?.status === OrderStatus.SHIPPED
                                  ? 'SHIPPED_ORDER_DETAIL'
                                  : 'CREATE_ORDER',
                            })}
                          </span>
                        </div>
                        {params?.id && (
                          <SelectNoFormik
                            classNameSelect='w-100px'
                            styleInput={{
                              minHeight: '40px',
                            }}
                            styleMenu={{
                              width: '250px',
                            }}
                            emptyDefault={false}
                            value={{
                              label:
                                isEmpty(formik.values?.tags) || isEmpty(dataTags) ? (
                                  loading.assignTag ? (
                                    <span className='indicator-progress' style={{display: 'block'}}>
                                      <span className='spinner-border spinner-border-sm align-middle ms-2' />
                                    </span>
                                  ) : (
                                    intl.formatMessage({id: 'TAG'})
                                  )
                                ) : (
                                  <div className='d-flex align-items-center'>
                                    {loading.assignTag && (
                                      <span
                                        className='indicator-progress'
                                        style={{display: 'block'}}
                                      >
                                        <span className='spinner-border spinner-border-sm align-middle ms-2' />
                                      </span>
                                    )}
                                    {formik.values?.tags.map((idTag, idx) => (
                                      <KTSVG
                                        key={idx}
                                        path='/media/gori/orders/tag.svg'
                                        className='svg-icon-2 ms-2'
                                        style={{color: find(dataTags, {id: idTag})?.color}}
                                      />
                                    ))}
                                  </div>
                                ),
                              value: '',
                            }}
                            options={optionsTag}
                            onChange={(e) => {
                              if (e.value === 'manage_tag') {
                                setIsClickMultiTags(false)
                                setShowModal((prev) => ({...prev, manageTag: true}))
                              }
                            }}
                            isSearchable={false}
                            disabled={isEmpty(optionsTag) || loading.assignTag}
                            isClickMulti={isClickMultiTags}
                          />
                        )}
                      </div>
                      <div className='d-flex align-items-center gap-2 order-child-header__actions'>
                        {data?.status === OrderStatus.SHIPPED &&
                        routes.SHIPMENTS_CREATE.hasPermission ? (
                          <div className='w-75px' />
                        ) : data?.status === OrderStatus.CANCELLED &&
                          routes.ORDERS_CANCEL.hasPermission ? (
                          <Button
                            className='btn btn-sm btn-advanced-primary'
                            label={intl.formatMessage({id: 'RESTORE'})}
                            loadingText={intl.formatMessage({id: 'RESTORE'})}
                            event={handleRestoreOrder}
                            loading={loading.restore}
                            disabled={loading.restore}
                          />
                        ) : data?.status === OrderStatus.ON_HOLD &&
                          routes.ORDERS_HOLD.hasPermission ? (
                          <Button
                            className='btn btn-sm btn-advanced-primary'
                            label={intl.formatMessage({id: 'REMOVE_HOLD'})}
                            loadingText={intl.formatMessage({id: 'REMOVE_HOLD'})}
                            event={handleRemoveHold}
                            loading={loading.restore}
                            disabled={loading.restore}
                          />
                        ) : (
                          <div
                            className={clsx({
                              'cursor-no-drop':
                                loading.createOrder || loading.save || isDisablePage,
                            })}
                          >
                            <Button
                              className={clsx('btn btn-sm me-3 btn-advanced-secondary', {
                                'text-hover-primary': canSave && checkValidateLeft,
                                'cursor-no-drop': !canSave || !checkValidateLeft,
                              })}
                              label={intl.formatMessage({id: 'SAVE'})}
                              loadingText={intl.formatMessage({id: 'SAVING'})}
                              event={() => {
                                setScrollToErrors(true)
                                formik.handleSubmit()
                                if (canSave) {
                                  params?.id ? setAction('save') : setAction('create_order')
                                }
                              }}
                              loading={loading.createOrder || loading.save}
                              disabled={
                                isDisablePage || loading.rate || !canSave || !checkValidateLeft
                              }
                            />
                          </div>
                        )}
                        {ButtonCreateLabel()}
                        {ButtonReship()}
                        {params?.id && (
                          <ActionsDetailButton
                            canSave={canSave}
                            data={data}
                            setData={setData}
                            disabled={loading.save || loading.createOrder || loading.createLabel}
                            className='h-39px'
                            onRefresh={() => {
                              row.current = {parcels: 0, order_items: 0, custom_items: 0}
                              getInitValue()
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className='d-flex flex-wrap col-12'>
                    {!isEmpty(data?.shipments) && params?.id && isShippedPage && (
                      <ShipmentTable
                        tableData={data?.shipments?.map((item) => ({
                          ...item,
                          extra_service: formik.values.extra_service,
                        }))}
                        tableClassName='mt-0 mb-24px w-100'
                        visibleColumns={shipmentVisibleColumns}
                      />
                    )}
                    <div className='col-12 col-xxl-7 order-child-main-col'>
                      <div
                        className={clsx('bg-white rounded-2 border', {
                          'bg-light cursor-no-drop': isDisablePage,
                          'border-primary': !isDisablePage && isShippedPage,
                        })}
                      >
                        {isShippedPage ? (
                          <div
                            className='d-flex justify-content-between align-items-center p-6 cursor-pointer'
                            onClick={() =>
                              setShowHide((prev) => ({
                                ...prev,
                                shipmentDetail: !prev.shipmentDetail,
                              }))
                            }
                          >
                            <span className='fs-2 fw-bolder required'>
                              {intl.formatMessage({id: 'SHIPMENT_DETAIL'})}
                            </span>

                            <span className='cursor-pointer text-hover-primary p-2 bg-hover-light-primary rounded-circle'>
                              <KTSVG
                                path='/media/gori/arrows/arrow_down.svg'
                                className='svg-icon-2'
                              />
                            </span>
                          </div>
                        ) : (
                          <div
                            className='d-flex justify-content-between align-items-center p-6'
                            onClick={() =>
                              setShowHide((prev) => ({
                                ...prev,
                                shipmentDetail: !prev.shipmentDetail,
                              }))
                            }
                          >
                            <span className='fs-2 fw-bolder required'>
                              {intl.formatMessage({id: 'SHIPMENT_DETAIL'})}
                            </span>
                            <PresetApplyButton
                              formik={formik}
                              disabled={isDisablePage}
                              fromCreateOrder={fromCreateOrder}
                              dataCopy={dataCopy}
                              setDataRates={rateRef.current?.setDataRates}
                              setPresetService={rateRef.current?.setPresetService}
                              renderFirst={renderFirst}
                            />
                          </div>
                        )}
                        {((showHide.shipmentDetail && isShippedPage) || !isShippedPage) && (
                          <div className='pb-6 px-6'>
                            <hr className='bg-gray-600 mt-0 mb-6' />
                            <div>
                              <div>
                                <div className='d-flex justify-content-between align-items-center'>
                                  <h3 className='fw-bolder fs-2'>
                                    {intl.formatMessage({id: 'SHIP_FROM'})}
                                  </h3>
                                  {!isShippedPage && (
                                    <div
                                      className='d-flex align-items-center btn btn-advanced-tertiary fs-inherit py-0 px-1 fw-bolder cursor-pointer'
                                      onClick={() => {
                                        setFormToModal({
                                          show: true,
                                          name: 'from',
                                          data: formik.getFieldProps('from').value,
                                          validate: validateAddress('from'),
                                        })
                                      }}
                                    >
                                      <span className='fs-2 me-1'>+</span>
                                      {intl.formatMessage({
                                        id: Object.values(
                                          omit(formik.getFieldProps('from').value, [
                                            'from_country',
                                            'from_is_residential',
                                          ])
                                        ).some((value) => !isEmpty(value))
                                          ? 'EDIT_ADDRESS'
                                          : 'NEW_ADDRESS',
                                      })}
                                    </div>
                                  )}
                                </div>
                                <EditAddress
                                  formik={formik}
                                  fromToModal={fromToModal}
                                  handleOpenFromToModal={(name, value) =>
                                    setFormToModal({
                                      show: true,
                                      name,
                                      data: value,
                                      validate: validateAddress(name),
                                    })
                                  }
                                  handleCloseFromToModal={() =>
                                    setFormToModal({
                                      show: false,
                                      name: undefined,
                                      data: {},
                                      validate: {},
                                    })
                                  }
                                  name='from'
                                  hasGetAddress={!fromCreateOrder}
                                  disabled={isDisablePage || hasPermissionView || isA1}
                                />
                              </div>
                              <div className='mt-4'>
                                <div className='d-flex justify-content-between align-items-center'>
                                  <h3 className='fw-bolder fs-2'>
                                    {intl.formatMessage({id: 'SHIP_TO'})}
                                  </h3>
                                  {!isShippedPage && (
                                    <div
                                      className='d-flex align-items-center btn btn-advanced-tertiary fs-inherit py-0 px-1 fw-bolder cursor-pointer'
                                      onClick={() => {
                                        setFormToModal({
                                          show: true,
                                          name: 'to',
                                          data: formik.values.to,
                                          validate: validateAddress('to'),
                                        })
                                      }}
                                    >
                                      <span className='fs-2 me-1'>+</span>
                                      {intl.formatMessage({
                                        id: Object.values(
                                          omit(formik.values.to, [
                                            'to_country',
                                            'to_is_residential',
                                          ])
                                        ).some((value) => !isEmpty(value))
                                          ? 'EDIT_ADDRESS'
                                          : 'NEW_ADDRESS',
                                      })}
                                    </div>
                                  )}
                                </div>
                                <EditAddress
                                  formik={formik}
                                  fromToModal={fromToModal}
                                  handleOpenFromToModal={(name, value) =>
                                    setFormToModal({
                                      show: true,
                                      name,
                                      data: value,
                                      validate: validateAddress(name),
                                    })
                                  }
                                  handleCloseFromToModal={() =>
                                    setFormToModal({
                                      show: false,
                                      name: undefined,
                                      data: {},
                                      validate: {},
                                    })
                                  }
                                  name='to'
                                  hasGetAddress={!fromCreateOrder}
                                  disabled={isDisablePage || hasPermissionView}
                                />
                              </div>
                            </div>
                            <div>
                              <PackageInfo
                                formik={formik}
                                disabled={isDisablePage || hasPermissionView}
                                hasGetPackage={!fromCreateOrder}
                                handleAddNewItem={handleAddNewItem}
                                handleDeleteItem={handleDeleteItem}
                                currentDimensionUnit={currentDimensionUnit}
                                setCurrentDimensionUnit={setCurrentDimensionUnit}
                                currentWeightUnit={currentWeightUnit}
                                setCurrentWeightUnit={setCurrentWeightUnit}
                              />
                            </div>
                            <div>
                              <div className='d-flex flex-wrap gap-2 justify-content-between mt-10 mb-2'>
                                <div className='fs-3 fw-bolder'>
                                  {intl.formatMessage({id: 'SHIPMENT_DATE'})}
                                </div>
                                <div
                                  className={clsx('d-flex col-12 col-sm-6', {
                                    'cursor-no-drop': isDisablePage || hasPermissionView,
                                  })}
                                >
                                  <InputDate
                                    className={clsx('col-12', {'pe-none': isDisablePage})}
                                    labelClassName='col-3 col-form-label text-nowrap text-muted'
                                    name='ship_by_date'
                                    formik={formik}
                                    min={moment()}
                                    dateTimeProps={shipmentDatePickerProps}
                                    disabled={isDisablePage || hasPermissionView}
                                    checkFormik={!isDisablePage && !hasPermissionView}
                                  />
                                </div>
                              </div>
                            </div>

                            {isShippedPage && (
                              <div>
                                <div className='d-flex flex-wrap gap-2 justify-content-between mt-10 mb-2'>
                                  <div className='fs-3 fw-bolder'>
                                    {intl.formatMessage({id: 'CUSTOMER_TRACKING_NUMBER'})}
                                  </div>
                                  <InputTextFormik
                                    className='col-6'
                                    labelClassName='col-3 col-form-label text-nowrap text-muted'
                                    name='customer_tracking_number'
                                    formik={formik}
                                    disabled={true}
                                    checkFormik={false}
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                      {!isShippedPage && formik.values.international && (
                        <div className='mt-24px'>
                          <CustomsInternational
                            formik={formik}
                            handleAddNewItem={handleAddNewItem}
                            handleDeleteItem={handleDeleteItem}
                            disabled={isDisablePage || hasPermissionView}
                            isShippedPage={isShippedPage}
                            showHide={showHide}
                            setShowHide={setShowHide}
                          />
                        </div>
                      )}
                      {!isShippedPage && (
                        <OrderDetail
                          isDisablePage={isDisablePage}
                          showHide={showHide.orderDetail}
                          setShowHide={setShowHide}
                          currentUser={currentUser}
                          data={data}
                          isA1={isA1}
                          hasPermissionView={hasPermissionView}
                          handleAddNewItem={handleAddNewItem}
                          handleDeleteItem={handleDeleteItem}
                          formik={formik}
                          className='mt-24px'
                        />
                      )}

                      {!isEmpty(data?.shipments) && params?.id && !isShippedPage && (
                        <ShipmentTable tableData={data?.shipments} tableClassName='mt-24px' />
                      )}
                      {data?.status === OrderStatus.SHIPPED &&
                        data?.latest_shipment &&
                        !isCreatedWithinLast30Days(data?.latest_shipment?.created_at) && (
                          <div className='fw-semibold fs-5 mt-10'>
                            <p
                              className='mb-0'
                              style={{textAlign: 'justify', color: '#64748B'}}
                              dangerouslySetInnerHTML={{
                                __html: intl.formatMessage({id: 'REPRINT_LABEL_4'}),
                              }}
                            />
                          </div>
                        )}
                    </div>
                    {isShippedPage && (
                      <div className='col-12 col-xxl-5 ps-0'>
                        {formik.values.international && (
                          <CustomsInternational
                            formik={formik}
                            handleAddNewItem={handleAddNewItem}
                            handleDeleteItem={handleDeleteItem}
                            disabled={isDisablePage || hasPermissionView}
                            isShippedPage={isShippedPage}
                            showHide={showHide}
                            setShowHide={setShowHide}
                          />
                        )}
                        <div className={clsx({'mt-24px': formik.values.international})}>
                          <OrderDetail
                            isDisablePage={isDisablePage}
                            showHide={showHide.orderDetail}
                            setShowHide={setShowHide}
                            currentUser={currentUser}
                            data={data}
                            isA1={isA1}
                            hasPermissionView={hasPermissionView}
                            handleAddNewItem={handleAddNewItem}
                            handleDeleteItem={handleDeleteItem}
                            formik={formik}
                            className='mt-5 mt-xl-0'
                          />
                        </div>
                      </div>
                    )}
                    {!isShippedPage && (
                      <OrderChildRate
                        ref={rateRef}
                        formik={formik}
                        setValidationErrors={setValidationErrors}
                        data={data}
                        id={params?.id}
                        isDisablePage={isDisablePage}
                        setRateLoading={(rate) => setLoading((prev) => ({...prev, rate}))}
                        isErrorUpicAccept={isErrorUpicAccept}
                        setIsErrorUpicAccept={setIsErrorUpicAccept}
                        bottomComponent={
                          <div>
                            {ButtonCreateLabel('p-3 fs-5')}
                            {ButtonReship()}
                          </div>
                        }
                        isAccept={isAccept}
                        setIsAccept={setIsAccept}
                      />
                    )}
                  </div>
                </div>
              )
            })()
          )}
        </>
      </CSSTransition>
    </>
  )
}

export {OrderChild}
